
// Base URL
//const BaseURL = 'https://localhost:44371/';
const BaseURL = 'https://amrapi.askmerealty.in/';

//Controller Names
const VendorLoginURL = BaseURL + "VendorLogin/";

const ZSections = BaseURL + "/ZSections/";

const CategoryFilterMaster = BaseURL + "/CategoryFilterMaster/";

const SZType = BaseURL + "/SZType/";

const Property = BaseURL + "/Property/";

const NewProperty = BaseURL + "/NewProperty/";

const PropertyImages = BaseURL + "/PropertyImages/";

const PropertyAmenities = BaseURL + "/PropertyAmenities/";

const PropertyNearAmenities = BaseURL + "/PropertyNearAmenities/";

const PropertyFloor = BaseURL + "/PropertyFloor/";

const PropertyDocument = BaseURL + "/PropertyDocument/";

const Subscription = BaseURL + "/Subscription/";

const HeroSection = BaseURL + "/HeroSection/";

const BannerSection = BaseURL + "/BannerSection/";

const PageBanner = BaseURL + "/PageBanner/";

const VendorProfile = BaseURL + "/VendorProfile/";

const PageURLMaster = BaseURL + "/PageURLMaster/";

const ContactUs = BaseURL + "/ContactUs/";

const EnquiryURL = BaseURL + "/Enquiry/";

const BlogURL = BaseURL + "/Blogs/";

const AMRDetail = BaseURL + "/AMRDetail/";

const WEBFAQ = BaseURL + "/WEBFAQ/";

const TrustedPartnerURL = BaseURL + "/TrustedPartner/";

const TestimonialURL = BaseURL + "/Testimonial/";

const StateURL = BaseURL + "/State/";

const CityURL = BaseURL + "/City/";
const AreaURL = BaseURL + "/Area/";

const NewsLetterURL = BaseURL + "/NewsLetter/";

const FurnishingMasterURL = BaseURL + "/FurnishingMaster/";

const PoliciesURL = BaseURL + "/Policies/";

const AboutUsURL = BaseURL + "/AboutUs/";

const InspectMode = BaseURL + "/InspectMode/";




export { BaseURL, VendorLoginURL, ZSections, CategoryFilterMaster, SZType, Property, NewProperty, PropertyImages, PropertyAmenities, PropertyNearAmenities, PropertyFloor, PropertyDocument, Subscription, HeroSection, BannerSection, PageBanner, VendorProfile, PageURLMaster, ContactUs, EnquiryURL, BlogURL, AMRDetail, WEBFAQ, TrustedPartnerURL, TestimonialURL, StateURL, CityURL, AreaURL, NewsLetterURL, FurnishingMasterURL, PoliciesURL, AboutUsURL, InspectMode };